type ClassValue = string | number | false | null | undefined

/** Joins CSS Module class names, dropping falsy branches. */
export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ')
}
